import { Component } from '@angular/core';

@Component({
  selector: 'app-card-skeleton',
  imports: [],
  templateUrl: './card-skeleton.component.html',
  styleUrl: './card-skeleton.component.scss',
  standalone: true,
})
export class CardSkeletonComponent {

}
